import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export function GCIcon({ size = 'small' }: IconProps) {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#a)">
                <rect width="64" height="64" rx="14.5" fill="url(#b)" />
                <rect width="64" height="64" rx="14.5" fill="url(#c)" />
                <rect width="64" height="64" rx="14.5" fill="url(#d)" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M50.76 43.15h-8.083a11.44 11.44 0 0 1-8.594-4.337 11.156 11.156 0 0 1-8.467 4.337h-5.708a11.443 11.443 0 0 1-7.787-3.416c-2.014-2.054-3.136-4.715-3.183-7.528v-.372C9.042 25.804 14.02 20.9 20.037 20.9h8.754v.153a4.55 4.55 0 0 1-1.99 3.763c-.95.591-2.194.598-2.247.598H20.77c-1.099 0-1.909.16-2.065.194-2.622.647-4.64 2.87-5.016 5.53-.06.418-.062.838-.056 1.195.05 3 2.14 5.602 5.083 6.33.151.031.955.192 2.049.192l.12-.001h3.513c1.201 0 2.079-.196 2.088-.198 2.277-.564 4.151-2.265 4.89-4.441.028-.097.047-.188.059-.26v-.003H20.77l.007-.16a4.529 4.529 0 0 1 4.53-4.346h6.71l.003-.025.014-.057A11.082 11.082 0 0 1 42.806 20.9h12.278v.153a4.558 4.558 0 0 1-2.312 3.962c-.888.402-1.848.408-1.889.408H43.54c-1.092 0-1.908.16-2.064.193-2.605.643-4.62 2.85-5.01 5.49a6.89 6.89 0 0 0 .182 2.879c.25.877.696 1.71 1.291 2.408a6.498 6.498 0 0 0 2.154 1.648 6.417 6.417 0 0 0 2.72.608h12.274l-.007.16a4.529 4.529 0 0 1-4.32 4.341"
                    fill="#00FF98"
                />
            </g>
            <defs>
                <radialGradient
                    id="c"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(32.74998 70.6251 -20.5885 9.54721 8.625 -3)"
                >
                    <stop stopColor="#00348A" />
                    <stop offset="1" stopColor="#00348A" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="d"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(74.476 10.664 7.203) scale(46.7039)"
                >
                    <stop stopColor="#00348A" />
                    <stop offset="1" stopColor="#00348A" stopOpacity="0" />
                </radialGradient>
                <linearGradient id="b" x1="33.25" y1="21.75" x2="53.25" y2="66.625" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#021644" />
                    <stop offset="1" stopColor="#051231" />
                </linearGradient>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h64v64H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
